import SaleDetailContainer from './SaleDetailContainer';
export default SaleDetailContainer;
